import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { AmyPacketSide } from "@/components/amy/amy-packet-side";
import { AdmissionPacketWorkspace } from "@/components/app/admission-packet/packet/workspace";

export const Route = createFileRoute("/_authenticated/ws/amy/$moveInId_/packet/$packetId")({
  head: () => ({ meta: [{ title: "Admission packet | Amy | People AI" }] }),
  component: AmyPacket,
});

/** A move-in's admission packet, opened inside Amy: the same guided intake and signing as from
 * the lead or the chart, with Amy beside it and the way back to the move-in. */
function AmyPacket() {
  const { moveInId, packetId } = Route.useParams();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-0 lg:h-[calc(100svh-3.5rem-var(--dock-h,0px))]">
      <div className="min-w-0 flex-1 overflow-y-auto">
        <AdmissionPacketWorkspace
          key={packetId}
          packetId={packetId}
          onOpenPacket={(next) =>
            navigate({
              to: "/ws/amy/$moveInId/packet/$packetId",
              params: { moveInId, packetId: next },
            })
          }
          back={
            <Link to="/ws/amy/$moveInId" params={{ moveInId }} className="hover:underline">
              Back to the move-in
            </Link>
          }
        />
      </div>
      <aside
        aria-label="Amy"
        className="bg-card hidden w-[360px] shrink-0 overflow-y-auto border-l p-5 lg:block"
      >
        <AmyPacketSide moveInId={moveInId} />
      </aside>
    </div>
  );
}
